<new-documentos [id_company]="id_company"></new-documentos>